import { render } from "./BondStrategies.vue?vue&type=template&id=2d229f7d&scoped=true"
import script from "./BondStrategies.vue?vue&type=script&lang=js"
export * from "./BondStrategies.vue?vue&type=script&lang=js"

import "./BondStrategies.vue?vue&type=style&index=0&id=2d229f7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d229f7d"]])

export default __exports__